import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

import { MonitoringService } from '../../../core/services/monitoring/monitoring.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { LinhaMonitoramentoVm } from '../../../core/models/monitoring-os.model'

// Só aparece pra OS em 12 (Aguardando Confirmação Operador). motivo é
// obrigatório — é o texto que o fornecedor lê no portal ao ver a OS voltar pra
// 13 (Em Reajuste), diferente de confirmar-atribuicao, que não pede nada.
@Component({
  selector: 'modal-recusar-atribuicao',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinner,
  ],
  templateUrl: './modal-recusar-atribuicao.component.html',
  styleUrl: './modal-recusar-atribuicao.component.scss',
})
export class ModalRecusarAtribuicaoComponent implements OnInit {
  @Output() response = new EventEmitter<boolean>()

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { item: LinhaMonitoramentoVm },
    private dialogRef: MatDialogRef<ModalRecusarAtribuicaoComponent>,
    private monitoringService: MonitoringService,
    private snackbar: SnackbarCustomService,
  ) {}

  form!: FormGroup
  saving = false

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      motivo: ['', Validators.required],
    })
  }

  recusar(): void {
    if (this.form.invalid) return
    this.saving = true
    this.monitoringService.recusarAtribuicao(this.data.item.codigoOs, this.form.value.motivo).subscribe({
      next: (res: any) => {
        this.saving = false
        this.snackbar.success(res.message ?? 'Atribuição recusada.')
        this.response.emit(true)
        this.dialogRef.close()
      },
      error: (err: any) => {
        this.saving = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  close(): void {
    this.dialogRef.close()
  }
}
